import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-overlay"
}
const _hoisted_2 = { class: "opciones-lista" }
const _hoisted_3 = { class: "form-grupo-nombre" }
const _hoisted_4 = { class: "cambiar-nombre-label" }
const _hoisted_5 = { class: "botones" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "botones" }
const _hoisted_8 = ["disabled"]

import { ref, watch } from 'vue'
import LoadingOverlay from '@/components/LoadingOverlay.vue'
import SelectorEstructuraArbol from '@/components/SelectorEstructuraArbol.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ClonarModeloModal',
  props: {
    visible: { type: Boolean },
    idModelo: {},
    idVersionOrigen: {}
  },
  emits: ["aceptar", "cancelar"],
  setup(__props: any, { emit: __emit }) {

/**
 * Clonación de un modelo.
 *
 * Copia SOLO la estructura, con filtro opcional por ordinal. El clon NO nace con
 * versión y, por tanto, no hereda indicadores: viven en la versión.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const props = __props

const emit = __emit

const opcion = ref<'completo' | 'seleccion' | ''>('')
const paso = ref<1 | 2>(1)
const cargando = ref(false)
const cambiarNombre = ref(false)
const nuevoNombre = ref('')
const selector = ref<InstanceType<typeof SelectorEstructuraArbol> | null>(null)

watch(() => props.visible, (v) => {
  if (v) {
    opcion.value = ''
    paso.value = 1
    cargando.value = false
    cambiarNombre.value = false
    nuevoNombre.value = ''
  }
})

function avanzar() {
  if (!opcion.value) return
  const nombreFinal = cambiarNombre.value && nuevoNombre.value.trim() ? nuevoNombre.value.trim() : undefined
  if (opcion.value === 'completo') {
    emit('aceptar', { opcion: 'completo', nuevoNombre: nombreFinal })
  } else {
    paso.value = 2
  }
}

function confirmar() {
  const nombreFinal = cambiarNombre.value && nuevoNombre.value.trim() ? nuevoNombre.value.trim() : undefined
  const ordinalesCalculados = selector.value?.obtenerOrdinales() ?? []
  emit('aceptar', { opcion: 'seleccion', ordinales: ordinalesCalculados, nuevoNombre: nombreFinal })
}

return (_ctx: any,_cache: any) => {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(LoadingOverlay, {
          visible: cargando.value,
          message: "Cargando estructura del modelo…"
        }, null, 8, ["visible"]),
        _createElementVNode("div", {
          class: _normalizeClass(["modal-contenido", { 'modal-grande': paso.value === 2 }])
        }, [
          _cache[12] || (_cache[12] = _createElementVNode("h4", { class: "modal-titulo" }, "Clonar Modelo", -1)),
          (paso.value === 1)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[10] || (_cache[10] = _createElementVNode("p", { class: "mensaje" }, "¿Cómo desea realizar la clonación?", -1)),
                _cache[11] || (_cache[11] = _createElementVNode("p", { class: "nota-clonacion" }, [
                  _createTextVNode(" El clon se crea como plantilla: copia la estructura, pero "),
                  _createElementVNode("strong", null, "no"),
                  _createTextVNode(" se genera una versión ni se copian indicadores. La versión se crea después con «Versionar». ")
                ], -1)),
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("label", {
                    class: _normalizeClass(["opcion-card", { seleccionada: opcion.value === 'completo' }])
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((opcion).value = $event)),
                      value: "completo"
                    }, null, 512), [
                      [_vModelRadio, opcion.value]
                    ]),
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "opcion-texto" }, [
                      _createElementVNode("strong", null, "Clonar modelo completo"),
                      _createElementVNode("span", { class: "opcion-desc" }, "Se copia toda la estructura del modelo.")
                    ], -1))
                  ], 2),
                  _createElementVNode("label", {
                    class: _normalizeClass(["opcion-card", { seleccionada: opcion.value === 'seleccion' }])
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((opcion).value = $event)),
                      value: "seleccion"
                    }, null, 512), [
                      [_vModelRadio, opcion.value]
                    ]),
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "opcion-texto" }, [
                      _createElementVNode("strong", null, "Escoger qué clonar"),
                      _createElementVNode("span", { class: "opcion-desc" }, [
                        _createTextVNode(" Verá el modelo completo y podrá pulsar la "),
                        _createElementVNode("span", { class: "x-ejemplo" }, "✕"),
                        _createTextVNode(" de los elementos que "),
                        _createElementVNode("em", null, "no"),
                        _createTextVNode(" desea incluir. ")
                      ])
                    ], -1))
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("label", _hoisted_4, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((cambiarNombre).value = $event)),
                      class: "cambiar-nombre-check"
                    }, null, 512), [
                      [_vModelCheckbox, cambiarNombre.value]
                    ]),
                    _cache[9] || (_cache[9] = _createTextVNode(" ¿Desea cambiar el nombre del modelo? "))
                  ]),
                  (cambiarNombre.value)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((nuevoNombre).value = $event)),
                        type: "text",
                        class: "form-input",
                        placeholder: "Nuevo nombre del modelo"
                      }, null, 512)), [
                        [_vModelText, nuevoNombre.value]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("button", {
                    class: "btn salir",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.$emit('cancelar')), ["stop"]))
                  }, "Cancelar"),
                  _createElementVNode("button", {
                    class: "btn guardar",
                    disabled: !opcion.value,
                    onClick: _withModifiers(avanzar, ["stop"])
                  }, _toDisplayString(opcion.value === 'completo' ? 'Clonar' : 'Siguiente '), 9, _hoisted_6)
                ])
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(SelectorEstructuraArbol, {
                  ref_key: "selector",
                  ref: selector,
                  idModelo: _ctx.idModelo,
                  "onUpdate:cargando": _cache[5] || (_cache[5] = ($event: any) => (cargando.value = $event))
                }, null, 8, ["idModelo"]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    class: "btn salir",
                    onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (paso.value = 1), ["stop"]))
                  }, "Volver"),
                  _createElementVNode("button", {
                    class: "btn guardar",
                    disabled: cargando.value,
                    onClick: _withModifiers(confirmar, ["stop"])
                  }, " Confirmar Clonación ", 8, _hoisted_8)
                ])
              ], 64))
        ], 2)
      ]))
    : _createCommentVNode("", true)
}
}

})